import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import interceptorsSetup from "./plugins/interceptors";

Vue.config.productionTip = false;

interceptorsSetup();
window.Axios = require("axios");
window.Swal = require("sweetalert2");
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
